// mobile.styles.js — 마케터 1:1 관리 휴대폰 화면 모양 (2026-10-06 UX 4단계)
//   누르는 곳은 40px 이상, 주요 버튼 44px 이상. 좌우 여백은 공통 틀(main px-4)이 준다.
const STAT_TONE = {
  ok: { bg: 'rgba(22,163,74,0.12)', fg: '#15803d' },
  blue: { bg: 'rgba(37,99,235,0.10)', fg: '#2563eb' },
  warn: { bg: 'rgba(245,158,11,0.14)', fg: '#b45309' },
  muted: { bg: 'rgba(100,116,139,0.14)', fg: 'var(--text-muted)' },
};

export const M = {
  page: { display: 'flex', flexDirection: 'column', gap: 12, minWidth: 0 },
  headRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap' },
  title: { margin: 0, fontSize: 20, fontWeight: 900, color: 'var(--text)' },
  sub: { marginTop: 6, fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.5 },
  headBtns: { display: 'flex', gap: 6, flexShrink: 0 },
  headBtn: (dark) => ({
    minHeight: 40, borderRadius: 10, padding: '0 12px', fontSize: 13, fontWeight: 800, cursor: 'pointer', whiteSpace: 'nowrap',
    border: dark ? '1px solid var(--std-btn, #0f172a)' : '1px solid var(--border)',
    background: dark ? 'var(--std-btn, #0f172a)' : 'var(--bg-card)', color: dark ? '#fff' : 'var(--text-sub)',
  }),
  // 회사 고르기(본사 화면에서 회사가 둘 이상) — PC 알약과 같은 톤, 높이만 40px
  companyTabs: {
    display: 'flex', gap: 2, padding: 3, borderRadius: 999, background: 'var(--bg-subtle)', overflowX: 'auto', maxWidth: '100%',
    alignSelf: 'flex-start',
  },
  companyTab: (active) => ({
    minHeight: 40, borderRadius: 999, padding: '0 14px', border: 'none', cursor: 'pointer', whiteSpace: 'nowrap', fontSize: 13,
    fontWeight: active ? 800 : 600,
    background: active ? 'var(--std-pill-on-bg, rgba(59,154,242,0.12))' : 'transparent',
    color: active ? 'var(--std-pill-on-text, #1d7de6)' : 'var(--text-muted)',
  }),

  // ── 배정 탭 ──
  stats: { display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', fontSize: 12, color: 'var(--text-muted)', fontWeight: 700 },
  stat: (tone) => ({
    borderRadius: 999, padding: '4px 10px', fontSize: 12, fontWeight: 800,
    background: STAT_TONE[tone]?.bg || STAT_TONE.ok.bg,
    color: STAT_TONE[tone]?.fg || STAT_TONE.ok.fg,
  }),
  primaryFull: {
    width: '100%', minHeight: 44, borderRadius: 12, border: 'none', background: 'var(--std-btn, #0f172a)', color: '#fff',
    fontSize: 14, fontWeight: 800, cursor: 'pointer',
  },
  seg: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4, padding: 4, borderRadius: 12, background: 'var(--bg-subtle)' },
  segBtn: (active) => ({
    minHeight: 40, borderRadius: 9, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: active ? 800 : 600,
    background: active ? 'var(--bg-card)' : 'transparent', color: active ? 'var(--text)' : 'var(--text-muted)',
    boxShadow: active ? '0 1px 2px rgba(0,0,0,0.08)' : 'none',
  }),
  search: {
    width: '100%', height: 44, borderRadius: 12, border: '1px solid var(--border)', padding: '0 14px', fontSize: 15,
    background: 'var(--bg-card)', color: 'var(--text)', boxSizing: 'border-box', outline: 'none',
  },
  card: { border: '1px solid var(--border)', borderRadius: 14, background: 'var(--bg-card)', overflow: 'hidden', minWidth: 0 },
  cardHead: {
    width: '100%', minHeight: 56, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10,
    padding: '8px 14px', border: 'none', background: 'var(--bg-subtle)', cursor: 'pointer', textAlign: 'left', boxSizing: 'border-box',
  },
  cardName: { fontSize: 15, fontWeight: 900, color: 'var(--text)' },
  cardMeta: { marginTop: 2, fontSize: 12, color: 'var(--text-muted)' },
  chevron: { fontSize: 14, color: 'var(--text-muted)', flexShrink: 0 },
  row: {
    width: '100%', minHeight: 60, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10,
    padding: '10px 14px', border: 'none', borderTop: '1px solid var(--border)', background: 'var(--bg-card)',
    cursor: 'pointer', textAlign: 'left', boxSizing: 'border-box',
  },
  rowName: { fontSize: 15, fontWeight: 800, color: 'var(--text)' },
  rowMeta: { marginTop: 3, fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.45, overflowWrap: 'anywhere' },
  rowSide: { display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 },
  badge: (tone) => ({
    borderRadius: 999, padding: '3px 9px', fontSize: 12, fontWeight: 800, whiteSpace: 'nowrap',
    background: tone === 'upcoming' ? 'rgba(37,99,235,0.10)' : tone === 'ended' ? 'rgba(100,116,139,0.14)' : 'rgba(22,163,74,0.12)',
    color: tone === 'upcoming' ? '#2563eb' : tone === 'ended' ? 'var(--text-muted)' : '#15803d',
  }),
  cardFoot: { display: 'grid', gridTemplateColumns: '1fr auto', gap: 8, padding: '10px 14px', borderTop: '1px solid var(--border)' },
  footBtn: (tone) => ({
    minHeight: 40, borderRadius: 10, padding: '0 14px', fontSize: 13, fontWeight: 800, cursor: 'pointer',
    border: tone === 'blue' ? '1px solid rgba(37,99,235,0.35)' : '1px solid var(--border)',
    background: tone === 'blue' ? 'rgba(37,99,235,0.08)' : 'var(--bg-card)', color: tone === 'blue' ? '#2563eb' : 'var(--text-sub)',
  }),
  emptyRow: { padding: '14px', borderTop: '1px solid var(--border)', fontSize: 13, color: 'var(--text-muted)', textAlign: 'center' },
  hiddenBox: { display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' },
  hiddenLabel: { fontSize: 12, fontWeight: 800, color: 'var(--text-muted)' },
  chipBtn: {
    minHeight: 40, borderRadius: 999, padding: '0 12px', border: '1px solid var(--border)', background: 'var(--bg-card)',
    color: 'var(--text-sub)', fontSize: 13, fontWeight: 700, cursor: 'pointer',
  },
  sectionTitle: { fontSize: 14, fontWeight: 900, color: 'var(--text)' },
  sectionHint: { fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.5 },
  empty: { padding: 24, textAlign: 'center', fontSize: 13, color: 'var(--text-muted)' },

  // ── 정산 탭 ──
  backBtn: {
    alignSelf: 'flex-start', minHeight: 44, borderRadius: 12, border: '1px solid var(--border)', background: 'var(--bg-card)',
    color: 'var(--text-sub)', fontSize: 14, fontWeight: 800, padding: '0 14px', cursor: 'pointer',
  },
  bottomSpacer: { height: 112 },
  bottomBar: {
    position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 40, background: 'var(--bg-card)', borderTop: '1px solid var(--border)',
    boxShadow: '0 -4px 16px rgba(15,23,42,0.08)', padding: '10px 16px calc(10px + env(safe-area-inset-bottom))',
    display: 'flex', flexDirection: 'column', gap: 6,
  },
  bottomRow: { display: 'grid', gridTemplateColumns: 'auto minmax(0, 1fr)', gap: 8 },
  bottomReason: { fontSize: 12, fontWeight: 700, color: '#b45309', textAlign: 'center' },
};
